module.exports = __webpack_public_path__ + "static/img/M-500-PORTLAND-CHERRY.d8435e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-500-PORTLAND-CHERRY.png
// module id = qOfm
// module chunks = 0